/** Cadence vocabulary shared by every screen that shows a session type. */
export const KICKOFF_CADENCES = ["weekly_kickoff", "monthly_kickoff", "quarterly_kickoff"];
export const REVIEW_CADENCES = ["weekly", "monthly", "quarterly"];

export const isKickoff = (cadence) => KICKOFF_CADENCES.includes((cadence || "").toLowerCase());

export const periodOf = (cadence) => (cadence || "weekly").toLowerCase().replace("_kickoff", "");

const LABELS = {
  weekly_kickoff: "Week kickoff",
  monthly_kickoff: "Month kickoff",
  quarterly_kickoff: "Quarter kickoff",
  weekly: "Weekly review",
  monthly: "Monthly review",
  quarterly: "Quarterly review",
};

export const cadenceLabel = (cadence) => LABELS[(cadence || "").toLowerCase()] || cadence || "session";

export const periodNoun = (cadence) => ({ weekly: "week", monthly: "month", quarterly: "quarter" }[periodOf(cadence)] || "week");
